import { GeneralErrors } from '.';
import { BackendError } from './base';

class InvalidPinId extends BackendError {}
class InvalidListingId extends BackendError {}
class ListingDoesNotExist extends GeneralErrors.NotFound {}

export default { InvalidPinId, InvalidListingId, ListingDoesNotExist };
